(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  /* Rotates the announcement bar messages one at a time while the stylesheet's container
     query puts the list in rotate mode (read from `--announcement-mode`, so the CSS stays
     the single source of truth for the 48 rem threshold). Every 5 s the next visible item
     takes the `is-current` class; touch, hover, focus and a hidden tab hold the rotation.
     Under reduced motion nothing rotates: the current message stays and the next control
     steps through the others. No live region: the change is not announced. */
  class AnnouncementRotator extends HTMLElement {
    connectedCallback() {
      this.next = this.querySelector('[data-announcement-next]');
      this.index = 0;
      this.held = false;
      this.interval = Number(this.dataset.interval || 5) * 1000;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.classList.add('is-ready');
      this.show(0);
      this.next?.addEventListener('click', () => { this.go(this.index + 1); this.start(); });
      this.addEventListener('focusin', (event) => {
        const item = event.target.closest('.announcement-bar__item');
        const index = this.items.indexOf(item);
        if (index > -1 && index !== this.index) this.show(index);
        this.hold(true);
      });
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.hold(false); });
      this.addEventListener('touchstart', () => this.hold(true), { passive: true });
      this.addEventListener('touchend', () => this.hold(false));
      this.addEventListener('touchcancel', () => this.hold(false));
      this.addEventListener('pointerenter', (event) => { if (event.pointerType === 'mouse') this.hold(true); });
      this.addEventListener('pointerleave', (event) => { if (event.pointerType === 'mouse') this.hold(false); });
      this.onVisibility = () => this.start();
      document.addEventListener('visibilitychange', this.onVisibility);
      this.onReduced = () => this.update();
      this.reduced.addEventListener('change', this.onReduced);
      this.observer = new ResizeObserver(() => this.update());
      this.observer.observe(this);
      this.update();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.timer = 0;
      this.observer?.disconnect();
      document.removeEventListener('visibilitychange', this.onVisibility);
      this.reduced.removeEventListener('change', this.onReduced);
    }

    get items() {
      return [...this.children].filter((el) => el.classList.contains('announcement-bar__item') && !el.hidden);
    }

    get rotating() {
      return getComputedStyle(this).getPropertyValue('--announcement-mode').trim() === 'rotate' && this.items.length > 1;
    }

    update() {
      const rotating = this.rotating;
      if (this.next) this.next.hidden = !(rotating && this.reduced.matches);
      this.start();
    }

    start() {
      clearInterval(this.timer);
      this.timer = 0;
      if (!this.rotating || this.reduced.matches || this.held || document.hidden) return;
      this.timer = setInterval(() => this.go(this.index + 1), this.interval);
    }

    hold(held) {
      this.held = held;
      this.start();
    }

    go(index) {
      const count = this.items.length;
      if (!count) return;
      this.show((index + count) % count);
    }

    show(index) {
      this.index = index;
      this.items.forEach((item, i) => item.classList.toggle('is-current', i === index));
    }
  }

  if (!customElements.get('announcement-rotator')) {
    customElements.define('announcement-rotator', AnnouncementRotator);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-cart-drawer]');
      this.titleText = this.querySelector('[data-cart-drawer-title-text]');
      this.querySelector('[data-cart-drawer-close]')?.addEventListener('click', () => this.close());
      this.dialog.addEventListener('click', (event) => {
        // Backdrop click, or a link flagged to close the drawer before it navigates.
        if (event.target === this.dialog || event.target.closest('[data-cart-drawer-link]')) this.close();
      });
      document.querySelectorAll('[data-cart-trigger]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
          event.preventDefault();
          this.open(false);
        });
      });
      document.addEventListener('cart:updated', (event) => {
        if (event.detail?.added) this.open(true);
      });
      this.addEventListener('cart:rendered', () => this.loadUpsell());
      this.loadUpsell();
    }

    open(added) {
      this.titleText.textContent = added ? this.dataset.titleAdded : this.dataset.title;
      if (!this.dialog.open) this.dialog.showModal();
      this.querySelector('[data-cart-drawer-close]')?.focus();
    }

    close() {
      this.dialog.close();
    }

    async loadUpsell() {
      const slot = this.querySelector('[data-cart-upsell]');
      const content = this.querySelector('[data-cart-content]');
      const productId = content?.dataset.firstProductId;
      if (!slot || !productId) return;
      const root = window.Shopify?.routes?.root || '/';
      const url = `${root}recommendations/products?section_id=cart-upsell&product_id=${productId}&limit=${this.dataset.upsellLimit || 4}&intent=related`;
      try {
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const upsell = doc.querySelector('[data-upsell]');
        if (upsell) {
          slot.replaceChildren(upsell);
          slot.hidden = false;
        } else {
          slot.hidden = true;
        }
      } catch (error) {
        slot.hidden = true;
      }
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-banner"] && !Shopify.designMode) return;
  try {
    
  // Opens the description band the link points at. The default anchor navigation is left
  // to the browser, so the address stays shareable and the back button returns the visitor
  // where they came from; the click only opens the <details> first, then puts the keyboard
  // on its summary, the control that closes it again. Without this script the link is
  // still an anchor that lands on the band, open or closed.
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('.collection-banner__more');
    if (!link) return;

    const target = document.querySelector(link.getAttribute('href'));
    if (!target || target.tagName !== 'DETAILS') return;

    target.open = true;
    const summary = target.querySelector('summary');
    if (summary) requestAnimationFrame(() => summary.focus({ preventScroll: true }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class FacetFilters extends HTMLElement {
    connectedCallback() {
      if (!this.querySelector('[data-facets-form]')) return;
      this.mobile = window.matchMedia('(max-width: 59.99rem)');
      this.syncDrawer();
      this.mobile.addEventListener('change', () => this.syncDrawer());
      this.addEventListener('click', (event) => {
        if (event.target.closest('[data-facets-close]')) {
          this.details.open = false;
          return;
        }
        const link = event.target.closest('[data-facets-remove], .pagination__link[href]');
        if (!link) return;
        event.preventDefault();
        this.load(link.href, true, link.classList.contains('pagination__link'));
      });
      this.addEventListener('submit', (event) => {
        if (!event.target.matches('[data-facets-form]')) return;
        event.preventDefault();
        this.apply();
        if (this.mobile.matches) this.details.open = false;
      });
      this.addEventListener('change', (event) => {
        if (!event.target.closest('[data-facets-form]') || event.target.matches('input[type="number"]')) return;
        this.apply();
      });
      let timer;
      this.addEventListener('input', (event) => {
        if (!event.target.matches('[data-facets-form] input[type="number"]')) return;
        clearTimeout(timer);
        timer = setTimeout(() => this.apply(), 600);
      });
      window.addEventListener('popstate', () => this.load(window.location.href, false, false));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.mobile.matches && this.details?.open) {
          this.details.open = false;
          this.querySelector('[data-facets-summary]')?.focus();
        }
      });
    }

    get form() {
      return this.querySelector('[data-facets-form]');
    }

    get details() {
      return this.querySelector('[data-facets]');
    }

    syncDrawer() {
      if (this.details) this.details.open = !this.mobile.matches;
    }

    apply() {
      const form = this.form;
      if (!form) return;
      const params = new URLSearchParams(new FormData(form));
      for (const [key, value] of [...params]) {
        if (value === '') params.delete(key);
      }
      const url = new URL(form.action, window.location.origin);
      url.search = params.toString();
      this.load(url.href, true, false);
    }

    async load(href, push, scroll) {
      this.controller?.abort();
      this.controller = new AbortController();
      this.setAttribute('aria-busy', 'true');
      const url = new URL(href, window.location.origin);
      url.hash = '';
      const fetchUrl = new URL(url.href);
      fetchUrl.searchParams.set('section_id', this.dataset.sectionId);
      try {
        const html = await (await fetch(fetchUrl, { signal: this.controller.signal })).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const results = doc.querySelector('[data-listing-results]');
        const sidebar = doc.querySelector('[data-listing-sidebar]');
        if (results) this.querySelector('[data-listing-results]').replaceWith(results);
        if (sidebar) {
          const wasOpen = this.details?.open;
          const focused = document.activeElement?.closest('[data-listing-sidebar]') ? document.activeElement.name + '=' + document.activeElement.value : null;
          this.querySelector('[data-listing-sidebar]').replaceWith(sidebar);
          this.details.open = wasOpen;
          if (focused) this.querySelector(`[data-facets-form] [name="${focused.split('=')[0]}"][value="${focused.split('=')[1]}"], [data-facets-form] [name="${focused.split('=')[0]}"]`)?.focus();
        }
        if (push) window.history.pushState({ facets: true }, '', url.href);
        if (scroll) this.querySelector('[data-listing-results]')?.scrollIntoView({ block: 'start' });
        this.dispatchEvent(new CustomEvent('facets:updated', { bubbles: true }));
      } catch (error) {
        if (error.name !== 'AbortError') window.location.href = url.href;
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('facet-filters')) {
    customElements.define('facet-filters', FacetFilters);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-addresses"]) return;
  try {
    
  document.querySelectorAll('.addresses__delete').forEach((form) => {
    form.addEventListener('submit', (event) => {
      if (!window.confirm(form.dataset.confirm)) event.preventDefault();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterDisclosures extends HTMLElement {
    connectedCallback() {
      this.compact = window.matchMedia('(max-width: 59.99rem)');
      this.sync();
      this.compact.addEventListener('change', () => this.sync());
      requestAnimationFrame(() => requestAnimationFrame(() => this.setAttribute('data-ready', '')));
    }

    sync() {
      const collapse = this.compact.matches && this.dataset.mobileMenus === 'accordion';
      this.querySelectorAll('.footer-disclosure').forEach((details) => {
        details.open = !collapse;
      });
    }
  }

  if (!customElements.get('footer-disclosures')) {
    customElements.define('footer-disclosures', FooterDisclosures);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderNav extends HTMLElement {
    connectedCallback() {
      this.closeTimer = null;
      this.triggers = [];
      // Only links Liquid marked as panel triggers (the panel has content) get behaviour.
      this.querySelectorAll('[data-mega-trigger]').forEach((trigger) => {
        const panel = this.querySelector(`#${trigger.dataset.megaTrigger}[data-mega-panel]`);
        if (!panel) return;
        const item = trigger.closest('.header__nav-item');
        this.triggers.push({ trigger, panel, item });
        item.addEventListener('mouseenter', () => this.open(trigger, panel));
        item.addEventListener('mouseleave', () => this.scheduleClose());
        panel.addEventListener('mouseenter', () => clearTimeout(this.closeTimer));
        panel.addEventListener('mouseleave', () => this.scheduleClose());
        trigger.addEventListener('click', (event) => {
          if (this.isCoarsePointer() && trigger.getAttribute('aria-expanded') !== 'true') {
            event.preventDefault();
            this.open(trigger, panel);
          }
        });
        trigger.addEventListener('focus', () => this.open(trigger, panel));
        panel.addEventListener('focusout', (event) => {
          if (!panel.contains(event.relatedTarget) && event.relatedTarget !== trigger) this.close(trigger, panel);
        });
        trigger.addEventListener('focusout', (event) => {
          if (!panel.contains(event.relatedTarget)) this.close(trigger, panel);
        });
      });
      this.addEventListener('keydown', (event) => this.onKeydown(event));
      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeAll();
      });

      this.drawer = this.querySelector('[data-menu-drawer]');
      this.opener = this.querySelector('[data-menu-open]');
      this.opener?.addEventListener('click', () => this.drawer.showModal());
      this.querySelector('[data-menu-close]')?.addEventListener('click', () => this.drawer.close());
      this.drawer?.addEventListener('close', () => this.opener?.focus());
      this.drawer?.addEventListener('click', (event) => {
        if (event.target === this.drawer) this.drawer.close();
      });
      this.fillDrawer();

      this.searchToggle = this.querySelector('[data-search-toggle]');
      this.searchWrapper = this.querySelector('[data-header-search-row]');
      this.searchToggle?.addEventListener('click', () => {
        const open = this.searchWrapper.classList.toggle('is-open');
        this.searchToggle.setAttribute('aria-expanded', String(open));
        if (open) this.searchWrapper.querySelector('input')?.focus();
      });

      this.countEl = this.querySelector('[data-cart-count]');
      this.totalEl = this.querySelector('[data-cart-total]');
      this.cartLink = this.querySelector('[data-cart-trigger]');
      document.addEventListener('cart:updated', (event) => this.updateCart(event.detail));

      this.bar = this.querySelector('.header__bar');
      this.row = this.querySelector('.header__row--top');
      this.navList = this.querySelector('.header__nav-list');
      this.wrapper = this.parentElement;
      this.mode = this.dataset.sticky;
      this.scrollThreshold = 4;
      this.lastY = window.scrollY;
      this.updateLayout();
      this.measure();
      new ResizeObserver(() => this.scheduleLayout()).observe(this);
      document.fonts?.ready.then(() => this.scheduleLayout(true));

      if (this.mode === 'compact') {
        window.addEventListener('scroll', () => this.scheduleScroll(), { passive: true });
        this.addEventListener('focusin', () => this.reveal());
        this.scheduleScroll();
      }
    }

    // The drawer shows the navigation of a panel, not the mega menu: a block that only
    // makes sense in the desktop composition marks itself data-drawer-omit (the promo
    // image and text, #139) and is left out of the clone.
    fillDrawer() {
      this.querySelectorAll('[data-drawer-item]').forEach((item) => {
        const panel = this.querySelector(`[data-mega-panel][data-parent="${item.dataset.drawerItem}"]`);
        if (!panel) return;
        const clone = panel.cloneNode(true);
        clone.removeAttribute('id');
        clone.removeAttribute('hidden');
        clone.removeAttribute('data-mega-panel');
        clone.querySelectorAll('[data-drawer-omit]').forEach((block) => block.remove());
        item.querySelector('[data-drawer-panel]').append(clone);
      });
    }

    isCoarsePointer() {
      return window.matchMedia('(hover: none)').matches;
    }

    // --header-height is what anchors and sticky panels clear: the bar when the whole header
    // sticks, the pinned row in compact mode (measured through the pinned layout before the
    // first pin, so the value never changes with the scroll), nothing when the header scrolls
    // away. In compact mode the wrapper also learns the in-flow height it must keep while the
    // header is pinned (only measurable in the flow; refreshed by the observer at unpin).
    measure() {
      if (!this.bar) return;
      let height = 0;
      if (this.mode === 'always') height = this.bar.offsetHeight;
      if (this.mode === 'compact') height = this.pinnedHeight();
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      if (this.mode === 'compact' && !this.hasAttribute('data-pinned')) {
        this.wrapper.style.setProperty('--header-flow-height', `${this.getBoundingClientRect().height}px`);
      }
    }

    pinnedHeight() {
      if (this.hasAttribute('data-pinned')) return this.bar.offsetHeight;
      let height = 0;
      this.settle(() => {
        this.setAttribute('data-pinned', '');
        height = this.bar.offsetHeight;
        this.removeAttribute('data-pinned');
      });
      return height;
    }

    // Applies a state change with no transition: the attribute switches the transition off,
    // the forced style flush commits the new state, then transitions come back for the
    // movements that follow.
    settle(change) {
      this.setAttribute('data-settling', '');
      change();
      void this.offsetHeight;
      this.removeAttribute('data-settling');
    }

    // Runs a frame later so the height change of a layout switch never lands inside the
    // observer's own delivery (which would log an undelivered-notifications error).
    scheduleLayout(force) {
      if (force) this.layoutWidth = null;
      cancelAnimationFrame(this.layoutFrame);
      this.layoutFrame = requestAnimationFrame(() => {
        this.updateLayout();
        this.measure();
      });
    }

    // Desktop only when the navigation holds on one line of its row and the top row (search,
    // logo, actions) fits as well; measured in the desktop layout, then written to
    // data-layout, which the stylesheet reads instead of its pre-script width guess. The
    // pinned desktop row then keeps the navigation only when it fits between the logo and
    // the icons without overflowing the bar (data-pinned-nav), else it shows the drawer
    // trigger. Both measurements swap the pinned state under data-settling, so a pinned
    // header measures in the flow and is pinned again before anything paints.
    updateLayout() {
      const width = this.clientWidth;
      if (width === this.layoutWidth) return;
      this.layoutWidth = width;
      const pinned = this.hasAttribute('data-pinned');
      this.settle(() => {
        this.removeAttribute('data-pinned');
        this.dataset.layout = 'desktop';
        const rowFits = !this.row || this.row.scrollWidth <= this.row.clientWidth;
        this.dataset.layout = this.navFits() && rowFits ? 'desktop' : 'compact';
        this.setAttribute('data-pinned', '');
        this.dataset.pinnedNav = 'nav';
        const barFits = !this.bar || this.bar.scrollWidth <= this.bar.clientWidth;
        this.dataset.pinnedNav = this.navFits() && barFits ? 'nav' : 'drawer';
        if (!pinned) this.removeAttribute('data-pinned');
      });
    }

    navFits() {
      const items = this.navList ? [...this.navList.children] : [];
      if (!items.length) return true;
      const navWidth = items[items.length - 1].getBoundingClientRect().right - items[0].getBoundingClientRect().left;
      return navWidth <= this.navList.clientWidth + 0.5;
    }

    scheduleScroll() {
      if (this.scrollFrame) return;
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = 0;
        this.updateScroll();
      });
    }

    // Compact mode, one pass per frame. In the flow, the header pins once it has scrolled out
    // of the viewport (hidden when the scroll went down, so nothing pops in; revealed with the
    // slide when it went up). Pinned, it returns to the flow once its own place (the wrapper)
    // is back in view, and only while out of sight so nothing visible moves (no layout
    // shift): hidden, at once; revealed, the row slides out first and the full header then
    // scrolls in with the page. Focus, the drawer or an open panel mean the shopper is using
    // the row, which returns at once instead. In between, the scroll direction hides or
    // reveals the row once the distance from the last accepted position passes the
    // threshold, so a few px of jitter never flip it.
    updateScroll() {
      if (this.mode !== 'compact') return;
      const maxY = document.documentElement.scrollHeight - window.innerHeight;
      const y = Math.max(0, Math.min(window.scrollY, maxY));
      const delta = y - this.lastY;
      if (!this.hasAttribute('data-pinned')) {
        if (this.getBoundingClientRect().bottom > 0) {
          this.lastY = y;
          return;
        }
        this.settle(() => {
          this.setAttribute('data-pinned', '');
          this.setAttribute('data-hidden', '');
        });
        if (delta < 0) this.removeAttribute('data-hidden');
        this.lastY = y;
        return;
      }
      if (this.wrapper.getBoundingClientRect().bottom > 0) {
        if (this.hasAttribute('data-hidden') || this.keepsRevealed()) {
          this.unpin();
        } else if (!this.unpinTimer) {
          this.setAttribute('data-hidden', '');
          const seconds = parseFloat(getComputedStyle(this).transitionDuration) || 0;
          this.unpinTimer = setTimeout(() => this.finishUnpin(), seconds * 1000);
        }
        this.lastY = y;
        return;
      }
      if (Math.abs(delta) < this.scrollThreshold) return;
      if (delta > 0) {
        if (!this.keepsRevealed()) this.setAttribute('data-hidden', '');
      } else {
        this.removeAttribute('data-hidden');
      }
      this.lastY = y;
    }

    // After the slide out: back to the flow unless the page scrolled down again meanwhile.
    finishUnpin() {
      this.unpinTimer = null;
      if (!this.hasAttribute('data-pinned') || !this.hasAttribute('data-hidden')) return;
      if (this.wrapper.getBoundingClientRect().bottom <= 0) return;
      this.unpin();
    }

    unpin() {
      clearTimeout(this.unpinTimer);
      this.unpinTimer = null;
      this.settle(() => {
        this.removeAttribute('data-pinned');
        this.removeAttribute('data-hidden');
        this.closeSearchRow();
      });
    }

    keepsRevealed() {
      return (
        this.matches(':focus-within') ||
        Boolean(this.drawer?.open) ||
        this.triggers.some((entry) => entry.trigger.getAttribute('aria-expanded') === 'true')
      );
    }

    reveal() {
      if (this.hasAttribute('data-pinned')) this.removeAttribute('data-hidden');
    }

    // The search row opened from the pinned row closes when the full header returns, unless
    // the shopper is typing in it.
    closeSearchRow() {
      if (!this.searchWrapper?.classList.contains('is-open')) return;
      if (this.searchWrapper.contains(document.activeElement)) return;
      this.searchWrapper.classList.remove('is-open');
      this.searchToggle?.setAttribute('aria-expanded', 'false');
    }

    open(trigger, panel) {
      clearTimeout(this.closeTimer);
      this.triggers.forEach((entry) => {
        if (entry.trigger !== trigger) this.close(entry.trigger, entry.panel);
      });
      trigger.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
    }

    close(trigger, panel) {
      trigger.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    }

    scheduleClose() {
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.closeAll(), 150);
    }

    closeAll() {
      this.triggers.forEach((entry) => this.close(entry.trigger, entry.panel));
    }

    onKeydown(event) {
      if (event.key === 'Escape') {
        const openEntry = this.triggers.find((entry) => entry.trigger.getAttribute('aria-expanded') === 'true');
        this.closeAll();
        openEntry?.trigger.focus();
        return;
      }
      const links = [...this.querySelectorAll('.header__nav-list > li > .header__nav-link')];
      const index = links.indexOf(document.activeElement);
      if (index === -1) return;
      if (event.key === 'ArrowRight') {
        event.preventDefault();
        links[(index + 1) % links.length].focus();
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        links[(index - 1 + links.length) % links.length].focus();
      } else if (event.key === 'ArrowDown') {
        const entry = this.triggers.find((candidate) => candidate.trigger === document.activeElement);
        const first = entry?.panel.querySelector('a, button');
        if (first) {
          event.preventDefault();
          this.open(entry.trigger, entry.panel);
          first.focus();
        }
      }
    }

    updateCart(cart) {
      if (!cart) return;
      if (this.countEl && typeof cart.item_count === 'number') {
        this.countEl.textContent = cart.item_count;
        this.countEl.hidden = cart.item_count === 0;
      }
      if (this.totalEl && cart.total_price_formatted) {
        this.totalEl.textContent = cart.total_price_formatted;
      }
      if (typeof cart.item_count === 'number') this.updateCartName(cart.item_count);
    }

    updateCartName(count) {
      const link = this.cartLink;
      if (!link || !link.dataset.cartName) return;
      const template = count === 1 ? link.dataset.cartItemsOne : link.dataset.cartItemsOther;
      if (!template) return;
      const total = this.totalEl ? ` ${this.totalEl.textContent.trim()}` : '';
      link.setAttribute('aria-label', `${link.dataset.cartName}${total}, ${template.replace('__count__', count)}`);
    }
  }

  if (!customElements.get('header-nav')) {
    customElements.define('header-nav', HeaderNav);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-slideshow-track]');
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.dots = [...this.querySelectorAll('[data-slideshow-dot]')];
      this.toggle = this.querySelector('[data-slideshow-toggle]');
      this.index = 0;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.querySelector('[data-slideshow-prev]')?.addEventListener('click', () => this.go(this.index - 1));
      this.querySelector('[data-slideshow-next]')?.addEventListener('click', () => this.go(this.index + 1));
      this.dots.forEach((dot) => dot.addEventListener('click', () => this.go(Number(dot.dataset.slideshowDot))));
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.go(this.index + 1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.go(this.index - 1); }
      });
      this.track?.addEventListener('scroll', () => this.syncFromScroll(), { passive: true });
      // Mouse drag (#99): the shared helper moves the track; the release decides the slide
      // from the distance dragged and goes there through `select`, so the index, the dashes
      // and the autoplay holds stay the element's. No wrap on a drag: the track ends there.
      if (this.track) {
        window.theme?.dragScroll?.(this.track, {
          onStart: () => {
            // The slide under the press, even mid-transition; a pending sync stands down.
            clearTimeout(this.scrollTimer);
            this.dragIndex = Math.round(this.track.scrollLeft / this.track.clientWidth);
          },
          onRelease: (delta) => this.select(this.dragTarget(delta)),
        });
      }
      this.toggle?.addEventListener('click', () => this.setPaused(!this.userPaused, true));
      this.addEventListener('mouseenter', () => this.hold(true));
      this.addEventListener('mouseleave', () => this.hold(false));
      this.addEventListener('focusin', () => this.hold(true));
      this.addEventListener('focusout', (event) => { if (!this.contains(event.relatedTarget)) this.hold(false); });
      document.addEventListener('visibilitychange', () => this.hold(document.hidden));
      this.userPaused = false;
      this.held = false;
      this.start();
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.running = false;
    }

    get autoplay() {
      return this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.reduced.matches;
    }

    start() {
      clearInterval(this.timer);
      this.running = false;
      if (!this.autoplay || this.userPaused || this.held) return;
      this.running = true;
      this.timer = setInterval(() => this.go(this.index + 1), Number(this.dataset.interval || 6) * 1000);
    }

    hold(held) {
      this.held = held;
      this.start();
    }

    setPaused(paused, fromUser) {
      this.userPaused = paused;
      if (this.toggle) {
        this.toggle.setAttribute('aria-pressed', String(paused));
        const label = paused ? this.toggle.dataset.labelPlay : this.toggle.dataset.labelPause;
        if (label) this.toggle.setAttribute('aria-label', label);
      }
      this.start();
    }

    go(index) {
      const left = this.select(index);
      if (left !== null) this.track.scrollTo({ left, behavior: this.reduced.matches ? 'auto' : 'smooth' });
    }

    /* Makes a slide the active one (index, dashes) and returns its scroll position; the
       index wraps around the ends. */
    select(index) {
      const count = this.slides.length;
      if (!count) return null;
      this.index = (index + count) % count;
      this.activate(this.index);
      return this.index * this.track.clientWidth;
    }

    /* Slide a drag of `delta` px lands on: the whole slides crossed (a long drag may pass
       several), plus one more once the remainder passes the fraction of a slide width,
       clamped to the ends. */
    dragTarget(delta) {
      const moved = -delta / this.track.clientWidth;
      const extra = Math.abs(moved % 1) >= HeroSlideshow.DRAG_FRACTION ? Math.sign(moved) : 0;
      const target = this.dragIndex + Math.trunc(moved) + extra;
      return Math.min(this.slides.length - 1, Math.max(0, target));
    }

    syncFromScroll() {
      // The drag and its settle own the position; `select` has already set the index.
      if (this.track.dataset.drag) return;
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        const index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        if (index !== this.index) { this.index = index; this.activate(index); }
      }, 80);
    }

    activate(index) {
      this.dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-selected', String(i === index));
      });
    }
  }

  /* Fraction of the slide width a drag must pass to move to the next or previous slide. */
  HeroSlideshow.DRAG_FRACTION = 0.2;

  if (!customElements.get('hero-slideshow')) {
    customElements.define('hero-slideshow', HeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popup"]) return;
  try {
    
  class SitePopup extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-popup]');
      if (!this.dialog) return;
      this.key = `popup:${this.dataset.popupId}`;
      this.querySelector('[data-popup-close]')?.addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => { if (event.target === this.dialog) this.dialog.close(); });
      this.dialog.addEventListener('close', () => this.remember());
      if (this.dataset.designMode === 'true') {
        document.addEventListener('shopify:section:select', (event) => { if (event.target.contains(this)) this.open(); });
        document.addEventListener('shopify:section:deselect', (event) => { if (event.target.contains(this)) this.dialog.close(); });
        if (this.dataset.enabled !== 'true') return;
      }
      if (this.dataset.enabled !== 'true' || !this.due()) return;
      setTimeout(() => this.open(), Number(this.dataset.delay || 3) * 1000);
    }

    due() {
      const frequency = Number(this.dataset.frequency);
      let last = null;
      try { last = localStorage.getItem(this.key); } catch (error) { return true; }
      if (!last) return true;
      if (frequency === 0) return true;
      if (frequency < 0) return false;
      return Date.now() - Number(last) > frequency * 86400000;
    }

    open() {
      if (this.dialog.open || document.querySelector('dialog[open]')) return;
      this.dialog.showModal();
      this.querySelector('[data-popup-close]')?.focus();
    }

    remember() {
      try { localStorage.setItem(this.key, String(Date.now())); } catch (error) { /* private mode */ }
    }
  }

  if (!customElements.get('site-popup')) {
    customElements.define('site-popup', SitePopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.querySelector('[data-recommendations]') || !this.dataset.productId) return;
      this.load();
    }

    async load() {
      const root = window.Shopify?.routes?.root || '/';
      const url = `${root}recommendations/products?section_id=${this.dataset.sectionId}&product_id=${this.dataset.productId}&limit=${this.dataset.limit || 8}&intent=${this.dataset.intent || 'related'}`;
      try {
        const html = await (await fetch(url)).text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const inner = doc.querySelector('[data-recommendations]');
        if (inner) {
          const slot = this.querySelector('[data-recommendations-slot]') || this;
          slot.replaceChildren(inner);
          this.hidden = false;
        } else {
          this.hidden = true;
        }
      } catch (error) {
        this.hidden = true;
      }
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  /* The reviews app renders its list again on every sort and every page change, so nothing
     the theme injects around that list survives (#106 left a grid for that reason). This
     element stays in the section's own markup instead: it moves itself next to the list,
     gives the list the shared track class and hands it to `theme-carousel`, and does it
     again each time the app puts a new list in place. In a section that holds no product
     review widget, and whose home box is not a scroll track at this width, it finds none:
     it draws nothing, its controls stay hidden and its observer only waits. */
  customElements.whenDefined('theme-carousel').then(() => {
    class ReviewsCarousel extends customElements.get('theme-carousel') {
      connectedCallback() {
        if (this.moving) return;
        this.widget = this.closest('.reviews__widget');
        if (!this.widget) return;
        this.observer ||= new MutationObserver(() => this.sync());
        this.observer.observe(this.widget, { childList: true, subtree: true });
        // The home box becomes drivable, or stops being, at the 60rem line: re-read on the way past.
        this.breakpoint ||= matchMedia('(min-width: 60rem)');
        this.breakpoint.addEventListener('change', () => this.sync());
        this.sync();
      }

      /* The app does not remove this element, it replaces the box it sits in, so being taken
         out of the document is the signal to wait for the next list rather than to stop: the
         observer watches the section's own wrapper, which the app never touches, and only
         stops once that wrapper has gone too (the section removed in the theme editor). */
      disconnectedCallback() {
        if (this.moving || this.widget?.isConnected) return;
        this.observer?.disconnect();
      }

      /* Sit right after the list the app renders, inside the box the app owns, and drive it.
         Every step is checked each time, so the list the app puts there next is picked up.

         Two lists can answer, one per block. The product Review Widget's is always drivable.
         The home carousel's own box only is below 60rem, where #121 turned it into a native
         scroll track; above, the app slides it with a transform and there is nothing for the
         theme to drive — attaching there would hand the keyboard a track the app does not
         scroll. The computed overflow is read rather than the width, so this stays in step
         with the CSS that decides it, whatever the breakpoint becomes (#125). */
      sync() {
        const productList = this.widget.querySelector('.jdgm-rev-widg__reviews');
        const homeBox = this.widget.querySelector('.jdgm-carousel__item-container');
        const scrollable = homeBox && getComputedStyle(homeBox).overflowX === 'auto';
        const track = productList || (scrollable ? homeBox : null);

        if (!track) {
          // Above 60rem after a resize: let go of the home box rather than keep driving it,
          // and give it back the shape it had — `attach()` makes a track focusable, and a
          // focusable box the app does not scroll is a tab stop that leads nowhere.
          if (this.track) {
            this.binding?.abort();
            this.track.removeAttribute('tabindex');
            this.track.classList.remove('carousel__track');
            this.track = null;
            this.removeAttribute('data-overflowing');
          }
          return;
        }

        track.classList.add('carousel__track');
        if (track.nextElementSibling !== this) {
          this.moving = true;
          track.after(this);
          this.moving = false;
        }
        this.attach(track);
      }
    }

    if (!customElements.get('reviews-carousel')) {
      customElements.define('reviews-carousel', ReviewsCarousel);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
